// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedCarouselStyles } from "@vanmeter/App/SharedStyles/ProductCarouselStyles";
import { purchasedProductsStyles } from "@vanmeter/Overrides/Widgets/Common/PurchasedProducts";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, mergeWithCss, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

purchasedProductsStyles.carouselProductMiniCardStyles = {
    ...sharedCarouselStyles.carouselProductMiniCardStyles,
};

purchasedProductsStyles.carouselProductCondensedStyles = {
    ...sharedCarouselStyles.carouselProductCondensedStyles,
};

purchasedProductsStyles.headerContainer = {
    ...mergeWithCss(purchasedProductsStyles.headerContainer, {
        css: css`
            background-color: ${color("common.ui7")};
        `,
    }),
};

purchasedProductsStyles.addToCartHeaderText =
    purchasedProductsStyles.priceHeaderText =
    purchasedProductsStyles.itemHeaderText =
        {
            weight: fontConfig.weight.bold,
            color: "common.white",
        };

purchasedProductsStyles.linesHeader = {
    wrapper: {
        css: css`
            ${({ showExtraCol }: any) =>
                showExtraCol
                    ? "grid-template-columns: 96px minmax(0, 1fr) minmax(0, 150px) minmax(0, 120px) minmax(0, 120px) minmax(0, 150px);"
                    : "grid-template-columns: 96px minmax(0, 1fr) minmax(0, 184px) minmax(0, 137px) minmax(0, 184px);"}

            ${xScreen("lte", "lg")} {
                ${({ showExtraCol }: any) =>
                    showExtraCol
                        ? "grid-template-columns: 96px minmax(0, 1fr) minmax(0, 120px) minmax(0, 130px) minmax(0, 100px) minmax(0, 120px);"
                        : "grid-template-columns: 96px minmax(0, 1fr) minmax(0, 154px) minmax(0, 114px) minmax(0, 154px);"}
            }
        `,
    },
};
